






































































































import { Banner, LineItem } from "@/models/campaign";
import DefinitionValue from "@/models/definitionValue";
import { UserModule } from "@/store/user";
import moment from "moment";
import { Component, Prop, Vue } from "vue-property-decorator";
import Modal from "@/components/Modal.vue";
import CampaignsAPI from "@/services/campaigns";
import { LayoutModule } from "@/store/layout";

@Component({ components: { Modal } })
export default class AvailabilityEntry extends Vue {
  @Prop() campaignName!: string;
  @Prop() status!: string;
  @Prop() statusColor!: string;
  @Prop() definitions!: DefinitionValue[];
  @Prop() lineItem!: LineItem;

  bannerDialog = false;
  banner: Banner = new Banner();

  get isAdmin(): boolean {
    return UserModule.isAdmin;
  }

  formatDate(date: Date): string {
    const d = moment(date).format("DD-MM-YYYY");
    return d;
  }

  goToCampaign(id: string): void {
    let routeData = this.$router.resolve({
      name: "edit-campaign",
      params: { id: id },
    });
    window.open(routeData.href, "_blank");
  }

  viewBanner(id: string): void {
    this.$nextTick(() => {
      this.bannerDialog = true;
    });

    this.getBanner();
  }

  async getBanner(): Promise<void> {
    LayoutModule.showLoader();

    try {
      const banner = await CampaignsAPI.lineItems.banners.get(
        this.lineItem.campaignId,
        this.lineItem.id
      );
      this.banner = new Banner(banner);
      console.log(this.banner);
    } catch (e) {
      console.log(e);
    }

    LayoutModule.hideLoader();
  }

  closeEditDialog(): void {
    this.bannerDialog = false;
    // this.$nextTick(() => {});
  }
  isHtml(source: string): boolean {
    return source.includes(".html");
  }
}
